<template>

    <div class="relative suggestive-search prose max-h-[calc(100vh_-_220px)]">
        <div class="input-form">
            <form :action="formActionSearch" method="GET" @submit="doSubmit">
                <label class="w-full text-center text-white text-fh3" :style="foregroundTextStyle" for="search">Search</label>
                <div class="inputs-container flex flex-nowrap content-center items-center ">
                    <input type="text" id="Search" name="Search" v-on:keyup="updateQuery" v-model="holdingSearchTerm"
                           class="border-0 px-[24px] text-white placeholder-white" :style="inputStyle"
                           placeholder="I'm looking for..."/>
                    <button v-if="holdingSearchTerm" class="border-0 border-none p-0 btn -ml-[37px] flex-center-all"
                            type="submit">
                        <span class="ph ph-magnifying-glass text-white text-[20px] ph-bold no-underline border-0 p-0"></span>
<!--                        <img :src="searchIcon" alt="Search icon" class="border-0 p-0 w-[20px]">-->
                    </button>
                    <a v-else :href="resultsPageClean" class="no-underline px-[27px] w-[50px] mb-[1px] flex-center-all" :style="foregroundTextStyle">
                        <span class="ph ph-magnifying-glass text-white text-[20px] ph-bold no-underline border-0 p-0 "></span>
<!--                        <img :src="searchIcon" alt="Search icon" class="border-0 p-0 w-[20px]">-->
                        <span class="sr-only">Search</span>
                    </a>
                </div>

            </form>
        </div>


        <div class="results bg-mega-menu-bg-rgb/60 text-center  rounded overflow-x-hidden overflow-y-auto top left max-w-2xl max-h-full w-full">
            <div>
                <div v-for="term in readPages"
                     class="cursor-pointer overflow-hidden p-4 "
                     v-on:click.prevent="goTo(term.absoluteLink)">
                    <p class="flex-1 text-fh5 font-bold text-left mb-0">
                        <a class="hover:text-header-bar-rgb" :href="term.absoluteLink">
                            {{ term.title }}
                        </a>
                    </p>
                    <div class="text-left" v-html="term.summary"></div>
                </div>
                <div v-if="readPages" class="cursor-pointer overflow-hidden p-4">
                    <p class="flex-1 text-fh5 text-left mb-0">
                        <a class="hover:text-header-bar-rgb" :href="formActionSearch">
                            See All Results
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="$apollo.queries.readPages.loading">
                Loading...
            </div>
        </div>


    </div>

</template>

<script>
import {debounce} from "lodash";
import gql from 'graphql-tag';

export default {
    name: "SuggestiveSearch",
    data: {
        holdingSearchTerm: '',
        searchTerm: ''
    },
    computed: {
        formActionSearch: function () {
            return decodeURIComponent(this.formAction) + '?Search=' + this.searchTerm + '&action_results=Go';
        },
        resultsPageClean: function () {
            return decodeURIComponent(this.formAction.replace('SearchForm/', ''));
        },
        inputStyle: function () {
            // return "background: red";
            return 'color: rgb(var(--color-mega-menu-bg)); placeholder: var('+ this.color +'); border-bottom: 1px solid var('+ this.color +')';
        },
        foregroundTextStyle: function () {
            return "color: var(" + this.color +'); text-decoration: none; border-bottom: 0;';
        }
    },
    props: {
        formAction: {
            type: String,
            required: false
        },
        searchIcon: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        }
    },
    methods: {
        goTo: function (link) {
            if (link) {
                window.location.href = link;
            }
        },
        doSubmit: function () {
            window.location.href = this.formActionSearch;
        },
        updateQuery: _.debounce(
            function () {
                this.searchTerm = (this.holdingSearchTerm.length > 2) ? this.holdingSearchTerm : '';
            }, 700)
    },
    apollo: {
        readPages: {
            query: gql`
                query readPages($searchTerm: String!) {
                    readPages(filter: {allContent: { contains: $searchTerm } }, limit: 4) {
                        nodes {
                          title
                          summary(searchTerm: $searchTerm)
                          metaDescription
                          absoluteLink
                        }
                    }
                }
            `,
            variables() {
                return {
                    searchTerm: this.searchTerm
                }
            },
            skip() {
                return this.searchTerm.length <= 2;
            },
            update: data => data.readPages.nodes
        }
    },
}
</script>

<style scoped>
    .results {
        backdrop-filter: blur(20px);
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(20px);

    }

    .inputs-container {
        border-radius: var(--button-main-rounding);
        background: rgba(255,255,255,0.1);
        backdrop-filter: blur(20px);
        height: 50px;
    }
    label {
        position: absolute;
        left: -9999px;
    }
    input {
        height: 50px;
        background: transparent;
        color: white;
    }
</style>
